import { Input } from "antd";
import React from "react";
import {
  Descriptions,
  DescriptionText,
  DescriptionTitle,
  FooterDescription,
  DescAlert,
} from "./style";

const Description = ({
  mainworkData = "",
  medium,
  title,
  onChange,
  value,
  workId,
  errorHelper,
  allowEdit,
  changeTitle,
  workTitle,
}) => {
  // const splitText = (description) => {
  //   if (description) {
  //     return description
  //       ?.trim()
  //       .split(".")
  //       .map((text, i) => {
  //         return text.length > 0 && <p key={`${i + 1}`}>{text}.</p>;
  //       });
  //   }
  // };

  return (
    <FooterDescription medium={medium}>
      <Descriptions>
        <DescriptionTitle>{title}</DescriptionTitle>
        <DescriptionText medium={medium}>
          {allowEdit ? (
            <>
              {changeTitle && (
                <div
                  style={{
                    padding: "5px 0px",
                  }}
                >
                  <div>Объект номи!</div>
                  <Input
                    placeholder="Объект номини киритинг!"
                    allowClear
                    onChange={(e) => onChange(e, "", "title")}
                    value={workTitle}
                    className={`${
                      errorHelper || workTitle?.length <= 0 ? "inputError" : ""
                    } input_body`}
                  />
                </div>
              )}
              <DescAlert>
                <div>
                  Изоҳ : ёзиш жараёнида регион туман исм фамилия ёзилмасин!
                </div>
                <div>{value?.length ?? 0}/700</div>
              </DescAlert>
              <Input.TextArea
                className={`${
                  errorHelper || value?.length === 700 ? "inputError" : ""
                } input_body`}
                value={value}
                maxLength="700"
                onChange={(e) => onChange(e, workId, "desc")}
                placeholder="Малумот ёзинг"
                autoSize={{ minRows: 5 }}
              />
            </>
          ) : mainworkData !== undefined ? (
            <div>{mainworkData}</div>
          ) : (
            "Изохлар йўқ!"
          )}
        </DescriptionText>
      </Descriptions>
    </FooterDescription>
  );
};

export default Description;
